/**
 * ================================
 * DAKCONFIGURATOR - MAIN ENTRY POINT
 * ================================
 *
 * Main entry point for the roof configurator application.
 * Handles DOM ready detection and starts the application initialization.
 *
 * This is the file that should be loaded in the Liquid template:
 * <script type="module" src="{{ 'dakconfigurator.main.js' | asset_url }}" defer></script>
 */

import { App } from './dakconfigurator.app.js';

console.log('🚀 Dakconfigurator module loaded');

/**
 * Starts the application
 * Wrapped in IIFE to prevent global namespace pollution
 */
(async function startDakconfigurator() {
  console.log('🎯 Starting dakconfigurator initialization...');
  /**
   * Main application startup function
   * Initializes the roof configurator and handles any errors
   */
  const startApplication = async () => {
    try {
      // Initialize the main application
      await App.initialize();

      // Note: Roof shape selection now automatically advances to next step
    } catch (error) {
      console.error('Roof configurator error:', error);
    }
  };

  // Safely start the application when the DOM is ready
  if (document.readyState === 'loading') {
    // DOM still loading, set up event listener
    document.addEventListener('DOMContentLoaded', startApplication);
  } else {
    // DOM already ready, start immediately
    startApplication();
  }
})();
